export function PageHeader({ kicker, title, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 pb-6 mb-6 border-b border-zinc-200">
      <div>
        {kicker && (
          <div className="text-xs font-mono text-zinc-500 uppercase tracking-widest mb-2">{kicker}</div>
        )}
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}

export function Stat({ label, value, hint, accent }) {
  return (
    <div className="card-flat p-5">
      <div className="text-xs font-mono uppercase tracking-widest text-zinc-500">{label}</div>
      <div className={`mt-2 font-display text-3xl font-bold tracking-tight ${accent || ""}`}>
        {value}
      </div>
      {hint && <div className="text-xs text-zinc-500 mt-1">{hint}</div>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    in_stock: ["bg-emerald-50 text-emerald-700 border-emerald-200", "IN STOCK"],
    partially_used: ["bg-amber-50 text-amber-700 border-amber-200", "PARTIAL"],
    fully_consumed: ["bg-zinc-100 text-zinc-600 border-zinc-200", "CONSUMED"],
    reserved: ["bg-blue-50 text-blue-700 border-blue-200", "RESERVED"],
    damaged: ["bg-rose-50 text-rose-700 border-rose-200", "DAMAGED"],
  };
  const [cls, label] = map[status] || ["bg-zinc-100 text-zinc-700 border-zinc-200", status];
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-mono uppercase tracking-wider border ${cls}`}>
      {label}
    </span>
  );
}

export function Field({ label, children, required }) {
  return (
    <div>
      <label className="block text-xs font-mono uppercase tracking-wider text-zinc-600 mb-1">
        {label} {required && <span className="text-rose-600">*</span>}
      </label>
      {children}
    </div>
  );
}

export function Input(props) {
  return (
    <input
      {...props}
      className={`w-full h-11 px-3 border border-zinc-300 focus:border-blue-600 outline-none text-sm ${props.className || ""}`}
    />
  );
}

export function Select({ children, ...props }) {
  return (
    <select
      {...props}
      className={`w-full h-11 px-3 border border-zinc-300 focus:border-blue-600 outline-none text-sm bg-white ${props.className || ""}`}
    >
      {children}
    </select>
  );
}

export function Btn({ variant = "primary", className = "", ...props }) {
  const styles = {
    primary: "btn-primary",
    secondary: "bg-white border border-zinc-300 text-zinc-900 hover:bg-zinc-100",
    danger: "bg-rose-600 text-white hover:bg-rose-700",
    ghost: "bg-transparent hover:bg-zinc-100 text-zinc-700",
  }[variant];
  return (
    <button
      {...props}
      className={`h-11 px-4 inline-flex items-center justify-center gap-2 font-medium text-sm transition-colors ${styles} ${className}`}
    />
  );
}


/**
 * Combobox — searchable dropdown with free-text fallback via <datalist>.
 * Use anywhere inventory/master values are repeated to prevent duplicate
 * spellings (e.g., "Acrylic Clear" vs "acrylic clear").
 */
export function Combobox({ options = [], value = "", onChange, listId, placeholder, testid, ...props }) {
  const id = listId || `cb-${Math.random().toString(36).slice(2)}`;
  return (
    <>
      <input
        list={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testid}
        className={`w-full h-11 px-3 border border-zinc-300 focus:border-blue-600 outline-none text-sm bg-white ${props.className || ""}`}
        {...props}
      />
      <datalist id={id}>
        {options.map((o) => <option key={o} value={o} />)}
      </datalist>
    </>
  );
}
